import * as React from "react";
import { Drawer as VaulDrawer } from "vaul";
import { X } from "lucide-react";

/**
 * Right-side detail drawer built on Vaul. Controlled by `open` prop.
 * Pattern established in Phase 1 for every future detail view.
 *
 * Usage:
 *   <DetailDrawer open={o} onOpenChange={setO} title="Isla Mackenzie" subtitle="Manager">
 *     <content />
 *   </DetailDrawer>
 */
export default function DetailDrawer({
  open, onOpenChange, title, subtitle, actions, children, testid = "detail-drawer",
}) {
  return (
    <VaulDrawer.Root open={open} onOpenChange={onOpenChange} direction="right">
      <VaulDrawer.Portal>
        <VaulDrawer.Overlay className="fixed inset-0 z-40 bg-black/30" />
        <VaulDrawer.Content
          data-testid={testid}
          className="fixed z-50 bg-card outline-none animate-drawer-in flex flex-col"
        >
          <VaulDrawer.Title className="sr-only">
            {title || "Detail"}
          </VaulDrawer.Title>
          <header className="flex items-start justify-between gap-3 px-5 py-4 border-b border-brand-rule">
            <div className="min-w-0">
              <div className="micro-label">Detail</div>
              <div className="mt-0.5 text-[17px] font-semibold text-brand-ink truncate">{title}</div>
              {subtitle ? (
                <div className="mt-0.5 text-[12px] text-brand-muted truncate">{subtitle}</div>
              ) : null}
            </div>
            <div className="flex items-center gap-1 shrink-0">
              {actions}
              <button
                type="button"
                onClick={() => onOpenChange(false)}
                className="btn-ghost h-8 w-8 !p-0"
                aria-label="Close"
                data-testid="detail-drawer-close"
              >
                <X size={15} />
              </button>
            </div>
          </header>
          <div className="flex-1 min-h-0 overflow-y-auto">{children}</div>
        </VaulDrawer.Content>
      </VaulDrawer.Portal>
    </VaulDrawer.Root>
  );
}
